import { render, staticRenderFns } from "./AttachmentDetail.vue?vue&type=template&id=4d41e89a&scoped=true&"
import script from "./AttachmentDetail.vue?vue&type=script&lang=js&"
export * from "./AttachmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentDetail.vue?vue&type=style&index=0&id=4d41e89a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d41e89a",
  null
  
)

export default component.exports